var _circle, _path, _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOpenInApp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 295 201",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 147.281,
    cy: 100.865,
    r: 76.3416,
    fill: "#F1F3F9"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_6945_78405)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6945_78405",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 84,
    y: 6,
    width: 126,
    height: 189
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M161.856 6.67033L90.1911 16.3532C86.6801 16.8276 84.3396 20.2211 85.1435 23.6715L123.804 189.614C124.585 192.963 128.01 194.975 131.315 194.026L205.259 172.791C208.402 171.888 210.247 168.637 209.408 165.475L168.468 11.085C167.692 8.157 164.858 6.26473 161.856 6.67033Z",
    fill: "#231C45"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6945_78405)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M161.856 6.67033L90.1911 16.3532C86.6801 16.8276 84.3396 20.2211 85.1435 23.6715L123.804 189.614C124.585 192.963 128.01 194.975 131.315 194.026L205.259 172.791C208.402 171.888 210.247 168.637 209.408 165.475L168.468 11.085C167.692 8.157 164.858 6.26473 161.856 6.67033Z",
    fill: "#231C45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.099 6.94586L91.9058 17.1727C89.4477 17.5308 87.8173 19.9091 88.3697 22.331L125.997 187.308C126.758 190.646 130.15 192.674 133.451 191.765L204.998 172.06C208.172 171.185 210.052 167.919 209.212 164.734L168.776 11.3601C167.997 8.40488 165.124 6.50523 162.099 6.94586Z",
    fill: "#231C45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.9779 17.6674L162.171 7.44063C164.944 7.03667 167.578 8.77825 168.293 11.4876L208.729 164.862C209.499 167.781 207.775 170.776 204.865 171.578L133.318 191.283C130.292 192.116 127.183 190.257 126.485 187.197L88.8571 22.2198C88.3697 20.0824 89.8085 17.9835 91.9779 17.6674Z",
    stroke: "#2DB2B2",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.839 10.2011L95.3294 19.894C93.3012 20.1987 91.9668 22.172 92.4393 24.1678L129.979 182.734C130.499 184.93 132.73 186.264 134.911 185.681L202.156 167.713C204.289 167.143 205.559 164.954 204.995 162.82L165.704 14.0579C165.019 11.4645 162.492 9.80253 159.839 10.2011Z",
    fill: "url(#paint0_linear_6945_78405)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6945_78405)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M144.829 80.0898L136.804 87.9826C136.427 88.2984 136.239 88.8309 136.375 89.3698C136.511 89.9087 136.944 90.3209 137.444 90.432L148.323 92.5953L153.122 88.938C153.122 88.938 144.878 81.3571 144.872 81.3571C144.763 81.2383 144.648 81.0844 144.607 80.9095C144.533 80.6015 144.64 80.2862 144.835 80.0898L144.829 80.0898Z",
    fill: "#2DB2B2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153.123 88.9379L148.324 92.5952L159.203 94.7586C159.398 94.8072 159.567 94.8839 159.716 94.9886L153.129 88.9449L153.123 88.9379Z",
    fill: "#7280FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M144.872 81.3567L153.129 88.9376L157.038 85.9612C157.436 85.6454 157.638 85.1058 157.502 84.5529C157.379 84.049 157.007 83.6717 156.561 83.5255L145.605 79.9059C145.477 79.8642 145.335 79.8574 145.193 79.8857C144.755 79.9846 144.492 80.4402 144.608 80.9021C144.656 81.0911 144.73 81.238 144.872 81.3497L144.872 81.3567Z",
    fill: "#00D5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M151.774 103.826L143.517 96.2455L139.608 99.2219C139.21 99.5378 139.009 100.077 139.145 100.63C139.267 101.134 139.639 101.511 140.085 101.658L151.035 105.277C151.163 105.319 151.305 105.326 151.446 105.29C151.885 105.192 152.147 104.736 152.032 104.274C151.984 104.085 151.91 103.938 151.768 103.826L151.774 103.826Z",
    fill: "#FFC000"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M151.817 105.094L159.841 97.1939C160.219 96.8781 160.407 96.3456 160.27 95.8067C160.134 95.2679 159.702 94.8556 159.202 94.7445L148.323 92.5812L143.524 96.2385L151.774 103.819C151.882 103.938 151.997 104.092 152.038 104.267C152.113 104.575 152.012 104.89 151.81 105.087L151.817 105.094Z",
    fill: "#FF3F8F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M143.524 96.2457L148.323 92.5883L137.444 90.432C137.248 90.3833 137.086 90.3136 136.938 90.2019L143.524 96.2457Z",
    fill: "#7280FF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_6945_78405",
    x: 79.9779,
    y: 1.60827,
    width: 132.637,
    height: 195.657,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1.00149,
    dy: -1.00149
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.00298
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.266667 0 0 0 0 0.337255 0 0 0 0 0.866667 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6945_78405"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6945_78405",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6945_78405",
    x1: 106.982,
    y1: 31.3249,
    x2: 224.608,
    y2: 206.473,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7F0FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6945_78405"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.9636,
    height: 25.4447,
    fill: "white",
    transform: "translate(136.316 79.8892) rotate(-0.111841)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenInApp);
export default __webpack_public_path__ + "static/media/open-in-app.d51ad3005b8161951bd278da0ed51566.svg";
export { ForwardRef as ReactComponent };